import React from "react";
import s from "../../style/home.module.less";
import { EVM_CLEANER_URL } from "../../lib/appBase";
import { useInWebShell } from "../../lib/webShell";
import { CHAINS } from "../../evm/chains";
import { chainLogo, EvmFlowArt, Pointer } from "../../evm/art";

/* The newest tool, featured above the toolkit. The EVM Dust Cleaner runs
   only on its own host (migration.<domain>, src/evm), so this links out,
   and it's left out of the dApp Store app. Its copy can't say "your keys
   stay in your wallet": the page takes pasted seed phrases and keys, and
   keeps them in the browser tab. */
const NAMED = [1, 56, 137, 42161, 10].map((id) => CHAINS.find((c) => c.id === id));

export const EvmFeature = () => {
  const inShell = useInWebShell();
  if (inShell) return null;
  return (
    <section className={s.section} aria-labelledby="evm-feature-h">
      <div className={s.evm}>
        <div className={s.evmCopy}>
          <span className={s.evmChip}>New · EVM to Solana</span>
          <h2 className={s.evmTitle} id="evm-feature-h">
            Turn EVM dust{" "}
            <span className={s.evmKeep}>
              into <span className={s.evmHi}>SOL</span>
            </span>
          </h2>
          <p className={s.evmLead}>
            The EVM Dust Cleaner finds what's left in your old EVM wallets on {CHAINS.length} chains, sells it through
            Relay and sends the SOL to your Solana address. Wallets with no ETH for gas can still sell.
          </p>
          <ul className={s.evmPoints}>
            <li>Paste seed phrases or private keys, many wallets at once</li>
            <li>Keys stay in the browser tab and are never sent to Solstack</li>
            <li>Check any wallet first by address, on the Wallet Scanner</li>
          </ul>
          {/* nofollow like every link into the app: its host keeps crawlers out. */}
          <a className={`ds-btn ${s.evmCta}`} href={EVM_CLEANER_URL} rel="nofollow">
            Open EVM Dust Cleaner <span aria-hidden="true">→</span>
          </a>
        </div>
        <div className={s.evmArt}>
          <EvmFlowArt className={s.evmFlow} />
          <div className={s.evmSide}>
            <ul className={s.evmChains} aria-label="Chains it sells from">
              {NAMED.map((c) => (
                <li key={c.id}>
                  <img src={chainLogo(c.id)} alt="" width="24" height="24" decoding="async" />
                  {c.name}
                </li>
              ))}
              <li className={s.evmMore}>+{CHAINS.length - NAMED.length} more</li>
            </ul>
            <Pointer className={s.evmPointer} />
            <span className={s.evmSol}>All into SOL</span>
          </div>
        </div>
      </div>
    </section>
  );
};
